export const menuProfile = [
	{ title: 'Профиль', to: '/profile' },
	{ title: 'Мои заказы', to: '/profile/orders' },
	{ title: 'Добавить заказ', to: '/profile/addorder' },
	{ title: 'Мои объявления', to: '/profile/plants' },
	{ title: 'Разместить объявление', to: '/profile/addPlant' },
	{ title: 'Избранное (заказы)', to: '/profile/favorite' },
	{ title: 'Избранное (оборудование)', to: '/profile/favoritePlants' },
	{ title: 'Диалоги', to: '/profile/chat' },
];
